import(/* webpackMode: "eager", webpackExports: ["NotificationBell"] */ "/srv/stocks-in-global/apps/web/components/forum/notifications/notification-bell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConvictionGauge"] */ "/srv/stocks-in-global/apps/web/components/recommendation/conviction-gauge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LiveNumber"] */ "/srv/stocks-in-global/apps/web/components/ui/live-number.tsx");
;
import(/* webpackMode: "eager" */ "/srv/stocks-in-global/node_modules/.pnpm/next@15.5.28_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_@types+node@22.19.19_react-dom@_5adenjdaadlbp72pm2heay6q7u/node_modules/next/dist/client/app-dir/link.js");
